import { observer } from "mobx-react";
import { LoanDetailsCardProps } from "../../summary/summaryStep";
import { LoanDetailsCardRentalPortfolio } from "./loanDetailsCardRentalPortfolio";

export const RentalPortfolioLoanDetailsCard = observer(
  ({ store }: LoanDetailsCardProps) => {

    return (
      <LoanDetailsCardRentalPortfolio
        store={store}
      />
    );
  }
);